import { NgModule } from '@angular/core';
import { IdlePreloadStrategy } from './services/preload/idle-preload.strategy';
import { RouterModule, Routes } from '@angular/router';
import { AuthUserGuard } from './guards/auth-user/auth-user.guard';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule)
  },
  {
    path: 'pagina-no-encontrada/',
    loadChildren: () => import('./pages/not-found/not-found.module').then(m => m.NotFoundPageModule)
  },
  {
    path: 'page/:page/',
    loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule)
  },
  {
    path: 'nuevos/',
    loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule),
    data: {
      tab: 'nuevos'
    }
  },
  {
    path: 'onfire/',
    loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule),
    data: {
      tab: 'onfire'
    }
  },
  {
    path: 'onfire-aliexpress/',
    loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule),
    data: {
      tab: 'onfire-aliexpress'
    }
  },
  {
    path: 'onfire-amazon/',
    loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule),
    data: {
      tab: 'onfire-amazon'
    }
  },
  {
    path: 'onfire-miravia/',
    loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule),
    data: {
      tab: 'onfire-miravia'
    }
  },
  {
    path: 'populares/',
    loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule),
    data: {
      tab: 'populares'
    }
  },
  {
    path: 'comentados/',
    loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule),
    data: {
      tab: 'comentados'
    }
  },
  {
    path: 'para_ti/',
    loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule),
    data: {
      tab: 'para_ti'
    }
  },
  {
    path: 'home/',
    loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule)
  },
  {
    path: 'tiendas/',
    data: { preload: 'intent' },
    loadChildren: () => import('./pages/stores/stores.module').then(m => m.StoresPageModule)
  },
  {
    path: 'reset-password/:user/:token/',
    loadChildren: () => import('./pages/recover-password/recover-password.module').then(m => m.RecoverPasswordPageModule)
  },
  {
    path: 'verify/:user/:token/',
    loadChildren: () => import('./pages/confirm/confirm.module').then(m => m.ConfirmPageModule)
  },
  {
    path: 'results/',
    loadChildren: () => import('./pages/product-category/product-category.module').then(m => m.ProductCategoryPageModule),
    data: {
      type: 'search'
    }
  },
  {
    path: 'tiendas/:id/',
    loadChildren: () => import('./pages/product-category/product-category.module').then(m => m.ProductCategoryPageModule),
    data: {
      type: 'store',
      oferta: true,
      tab: 'offer',
    }
  },
  // Pestañas de /cupones/ (listado sin :id). Rutas propias para que el href de cada
  // pestaña sea navegable sin JS (arranque diferido) y enlazable; van ANTES de
  // cupones/:id/ para que "nuevos" no se interprete como el slug de una tienda.
  {
    path: 'cupones/onfire/',
    loadChildren: () => import('./pages/product-category/product-category.module').then(m => m.ProductCategoryPageModule),
    data: {
      type: 'coupon',
      tab: 'onfire',
    }
  },
  {
    path: 'cupones/nuevos/',
    loadChildren: () => import('./pages/product-category/product-category.module').then(m => m.ProductCategoryPageModule),
    data: {
      type: 'coupon',
      tab: 'nuevos',
    }
  },
  {
    path: 'cupones/populares/',
    loadChildren: () => import('./pages/product-category/product-category.module').then(m => m.ProductCategoryPageModule),
    data: {
      type: 'coupon',
      tab: 'populares',
    }
  },
  {
    path: 'cupones/:id/',
    loadChildren: () => import('./pages/product-category/product-category.module').then(m => m.ProductCategoryPageModule),
    data: {
      type: 'store',
      oferta: false,
      tab: 'coupon',
    }
  },
  {
    path: 'tiendas/:id/onfire/',
    loadChildren: () => import('./pages/product-category/product-category.module').then(m => m.ProductCategoryPageModule),
    data: {
      type: 'store',
      oferta: false,
      tab: 'onfire',
    }
  },
  // {
  //   path: 'tiendas/:id/page/:page/',
  //   loadChildren: () => import('./pages/product-category/product-category.module').then(m => m.ProductCategoryPageModule),
  //   data: {
  //     type: 'store'
  //   }
  // },
  {
    path: 'tiendas/letter/:letter/',
    loadChildren: () => import('./pages/stores/stores.module').then(m => m.StoresPageModule),
    // data: {
    //   type: 'store',
    //   alphabetStore: true
    // }
  },
  {
    path: 'grupos/:id/',
    loadChildren: () => import('./pages/product-category/product-category.module').then(m => m.ProductCategoryPageModule),
    data: {
      type: 'group'
    }
  },
  {
    path: 'cupones/',
    loadChildren: () => import('./pages/product-category/product-category.module').then(m => m.ProductCategoryPageModule),
    data: {
      type: 'coupon'
    }
  },
  {
    path: 'categorias/',
    data: { preload: 'intent' },
    loadChildren: () => import('./pages/categories/categories.module').then(m => m.CategoriesPageModule)
  },
  {
    path: 'categorias/todas/',
    loadChildren: () => import('./pages/categories/categories.module').then(m => m.CategoriesPageModule),
    data: {
      all: true
    }
  },
  {
    path: 'grupos/',
    loadChildren: () => import('./pages/groups/groups.module').then(m => m.GroupsPageModule)
  },
  {
    path: 'chats/',
    loadChildren: () => import('./pages/chats/chats.module').then(m => m.ChatsPageModule),
    canActivate: [AuthUserGuard]
  },

  {
    path: 'chats/:id/',
    loadChildren: () => import('./pages/chats/chats.module').then(m => m.ChatsPageModule),
    canActivate: [AuthUserGuard]
  },
  {
    // Pantalla Cuenta de la barra inferior (odd/tasks/movil-cabecera-tarjeta-cuenta.md, S6).
    path: 'cuenta/',
    loadComponent: () => import('./pages/cuenta/cuenta.page').then(m => m.CuentaPage),
    canActivate: [AuthUserGuard]
  },
  {
    path: 'settings/',
    loadChildren: () => import('./pages/settings/settings.module').then(m => m.SettingsPageModule),
    canActivate: [AuthUserGuard]
  },
  {
    path: 'user/:id/',
    loadChildren: () => import('./pages/user/user-page.module').then(m => m.UserPageModule)
  },
  {
    path: 'user/:id/:type/',
    loadChildren: () => import('./pages/user/user-page.module').then(m => m.UserPageModule)
  },
  {
    path: 'compartir-chollo/',
    loadChildren: () => import('./pages/share-chollo/share-chollo.module').then(m => m.ShareCholloPageModule),
    data: {
      type: 'shop'
    }
  },
  {
    path: 'compartir-cupon/',
    loadChildren: () => import('./pages/share-chollo/share-chollo.module').then(m => m.ShareCholloPageModule),
    data: {
      type: 'cupon'
    }
  },
  {
    path: 'summer-sale/',
    loadChildren: () => import('./pages/summer-sale/summer-sale.module').then(m => m.SummerSalePageModule)
  },
  {
    path: 'summer-days/',
    loadChildren: () => import('./pages/summer-days/summer-days.module').then(m => m.SummerDaysPageModule)
  },
  {
    path: 'prime-day/',
    loadChildren: () => import('./pages/prime-day/prime-day.module').then(m => m.PrimeDayPageModule)
  },
  {
    path: 'miravia/',
    loadChildren: () => import('./pages/miravia/miravia.module').then(m => m.MiraviaPageModule)
  },
  {
    path: 'miravia/onfire/',
    loadChildren: () => import('./pages/miravia/miravia.module').then(m => m.MiraviaPageModule),
    data: {
      tab: 'onfire',
    }
  },
  {
    path: 'miravia/populares/',
    loadChildren: () => import('./pages/miravia/miravia.module').then(m => m.MiraviaPageModule),
    data: {
      tab: 'populares',
    }
  },
  {
    path: 'miravia/nuevos/',
    loadChildren: () => import('./pages/miravia/miravia.module').then(m => m.MiraviaPageModule),
    data: {
      tab: 'nuevos',
    }
  },
  {
    path: 'halloween-day/',
    loadChildren: () => import('./pages/halloween-day/halloween-day.module').then(m => m.HalloweenDayPageModule)
  },
  {
    path: 'blackfriday/nuevos/',
    loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule),
    data: {
      tab: 'nuevos',
      landingPage: 'blackfriday/',
      tituloLanding: 'Black Friday',
      tags: '2027'
    }
  },
  {
    path: 'blackfriday/onfire/',
    loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule),
    data: {
      tab: 'onfire',
      landingPage: 'blackfriday/',
      tituloLanding: 'Black Friday',
      tags: '2027'
    }
  },
  {
    path: 'blackfriday/populares/',
    loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule),
    data: {
      tab: 'populares',
      landingPage: 'blackfriday/',
      tituloLanding: 'Black Friday',
      tags: '2027'
    }
  },
  {
    path: 'blackfriday/comentados/',
    loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule),
    data: {
      tab: 'comentados',
      landingPage: 'blackfriday/',
      tituloLanding: 'Black Friday',
      tags: '2027'
    }
  },
  {
    path: 'blackfriday/para_ti/',
    loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule),
    data: {
      tab: 'para_ti',
      landingPage: 'blackfriday/',
      tituloLanding: 'Black Friday',
      tags: '2027'
    }
  },
  {
    path: 'blackfriday/',
    loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule),
    data: {
      landingPage: 'blackfriday/',
      tituloLanding: 'Black Friday',
      tags: '2027'
    }
  },
  {
    path: 'price-palace/nuevos/',
    loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule),
    data: {
      tab: 'nuevos',
      landingPage: 'price-palace/',
      tags: '1940'
    }
  },
  {
    path: 'price-palace/onfire/',
    loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule),
    data: {
      tab: 'onfire',
      landingPage: 'price-palace/',
      tags: '1940'
    }
  },
  {
    path: 'price-palace/populares/',
    loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule),
    data: {
      tab: 'populares',
      landingPage: 'price-palace/',
      tags: '1940'
    }
  },
  {
    path: 'price-palace/comentados/',
    loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule),
    data: {
      tab: 'comentados',
      landingPage: 'price-palace/',
      tags: '1940'
    }
  },
  {
    path: 'price-palace/para_ti/',
    loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule),
    data: {
      tab: 'para_ti',
      landingPage: 'price-palace/',
      tags: '1940'
    }
  },
  {
    path: 'price-palace/',
    loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule),
    data: {
      landingPage: 'price-palace/',
      tags: '1940'
    }
  },
  {
    path: 'aliexpressplaza/nuevos/',
    loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule),
    data: {
      tab: 'nuevos',
      landingPage: 'aliexpressplaza/',
      tags: '48'
    }
  },
  {
    path: 'aliexpressplaza/onfire/',
    loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule),
    data: {
      tab: 'onfire',
      landingPage: 'aliexpressplaza/',
      tags: '48'
    }
  },
  {
    path: 'aliexpressplaza/populares/',
    loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule),
    data: {
      tab: 'populares',
      landingPage: 'aliexpressplaza/',
      tags: '48'
    }
  },
  {
    path: 'aliexpressplaza/comentados/',
    loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule),
    data: {
      tab: 'comentados',
      landingPage: 'aliexpressplaza/',
      tags: '48'
    }
  },
  {
    path: 'aliexpressplaza/para_ti/',
    loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule),
    data: {
      tab: 'para_ti',
      landingPage: 'aliexpressplaza/',
      tags: '48'
    }
  },
  {
    path: 'aliexpressplaza/',
    loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule),
    data: {
      landingPage: 'aliexpressplaza/',
      tags: '48'
    }
  },
  {
    path: '11-11/nuevos/',
    loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule),
    data: {
      tab: 'nuevos',
      landingPage: '11-11/',
      tituloLanding: '11.11',
      tags: '451'
    }
  },
  {
    path: '11-11/onfire/',
    loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule),
    data: {
      tab: 'onfire',
      landingPage: '11-11/',
      tituloLanding: '11.11',
      tags: '451'
    }
  },
  {
    path: '11-11/populares/',
    loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule),
    data: {
      tab: 'populares',
      landingPage: '11-11/',
      tituloLanding: '11.11',
      tags: '451'
    }
  },
  {
    path: '11-11/comentados/',
    loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule),
    data: {
      tab: 'comentados',
      landingPage: '11-11/',
      tituloLanding: '11.11',
      tags: '451'
    }
  },
  {
    path: '11-11/para_ti/',
    loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule),
    data: {
      tab: 'para_ti',
      landingPage: '11-11/',
      tituloLanding: '11.11',
      tags: '451'
    }
  },
  {
    path: '11-11/',
    loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule),
    data: {
      landingPage: '11-11/',
      tituloLanding: '11.11',
      tags: '451'
    }
  },
  {
    path: 'navidad/nuevos/',
    loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule),
    data: {
      tab: 'nuevos',
      landingPage: 'navidad/',
      tituloLanding: 'Navidad',
      tags: '1593'
    }
  },
  {
    path: 'navidad/onfire/',
    loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule),
    data: {
      tab: 'onfire',
      landingPage: 'navidad/',
      tituloLanding: 'Navidad',
      tags: '1593'
    }
  },
  {
    path: 'navidad/populares/',
    loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule),
    data: {
      tab: 'populares',
      landingPage: 'navidad/',
      tituloLanding: 'Navidad',
      tags: '1593'
    }
  },
  {
    path: 'navidad/comentados/',
    loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule),
    data: {
      tab: 'comentados',
      landingPage: 'navidad/',
      tituloLanding: 'Navidad',
      tags: '1593'
    }
  },
  {
    path: 'navidad/para_ti/',
    loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule),
    data: {
      tab: 'para_ti',
      landingPage: 'navidad/',
      tituloLanding: 'Navidad',
      tags: '1593'
    }
  },
  {
    path: 'navidad/',
    loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule),
    data: {
      landingPage: 'navidad/',
      tituloLanding: 'Navidad',
      tags: '1593'
    }
  },
  {
    path: 'faqs/',
    loadChildren: () => import('./pages/faqs/faqs.module').then(m => m.FaqsPageModule)
  },
  {
    path: 'politica-de-privacidad/',
    loadChildren: () => import('./pages/privacy-policy/privacy-policy.module').then(m => m.PrivacyPolicyPageModule)
  },
  {
    path: 'aviso-legal/',
    loadChildren: () => import('./pages/legal-warning/legal-warning.module').then(m => m.LegalWarningPageModule)
  },
  {
    path: 'politica-de-cookies/',
    loadChildren: () => import('./pages/cookies-policy/cookies-policy.module').then(m => m.CookiesPolicyPageModule)
  },
  {
    path: 'normas-comunitarias/',
    loadChildren: () => import('./pages/community-norms/community-norms.module').then(m => m.CommunityNormsPageModule)
  },
  {
    path: 'reglas-de-publicacion/',
    loadChildren: () => import('./pages/posting-rules/posting-rules.module').then(m => m.PostingRulesPageModule)
  },
  {
    path: 'michollo-team/:currentTab/',
    loadChildren: () => import('./pages/michollo-team/michollo-team.module').then(m => m.MicholloTeamPageModule)
  },
  // },
  // },
  {
    path: 'download-app/',
    loadChildren: () => import('./pages/download-app/download-app.module').then(m => m.DownloadAppPageModule),
  },
  // Portal de partners (odd/tasks/partners.md, S6 y S8). Cada página es su propio trozo perezoso
  // y sin `preload`: nada del portal se descarga en las páginas públicas. Va antes de `:id/`, que
  // trataría «seller» como una categoría.
  {
    path: 'seller/',
    loadComponent: () => import('./seller/seller-inicio.page').then(m => m.SellerInicioPage)
  },
  {
    path: 'seller/alta/',
    loadComponent: () => import('./seller/seller-alta.page').then(m => m.SellerAltaPage)
  },
  {
    path: 'seller/verificar/',
    loadComponent: () => import('./seller/seller-verificar.page').then(m => m.SellerVerificarPage)
  },
  {
    path: 'seller/entrar/',
    loadComponent: () => import('./seller/seller-entrar.page').then(m => m.SellerEntrarPage)
  },
  {
    path: 'seller/recuperar/',
    loadComponent: () => import('./seller/seller-recuperar.page').then(m => m.SellerRecuperarPage)
  },
  {
    // El guardián (sin sesión de partner → /seller/entrar/) viaja en el mismo trozo que el panel.
    path: 'seller/panel/',
    loadChildren: () => import('./seller/seller-panel.routes').then(m => m.RUTAS_PANEL)
  },
  {
    path: 'seller/chollos/nuevo/',
    loadChildren: () => import('./seller/seller-chollos.routes').then(m => m.RUTAS_SUBIR)
  },
  {
    path: 'seller/chollos/',
    loadChildren: () => import('./seller/seller-chollos.routes').then(m => m.RUTAS_CHOLLOS)
  },
  {
    // Bandeja del equipo (S12): sesión de la WEB, no la de partner. La página decide qué enseña
    // según el rol (editor o más; Planes, admin o más) y la API lo vuelve a comprobar.
    path: 'seller/gestion/',
    loadComponent: () => import('./seller/seller-gestion.page').then(m => m.SellerGestionPage)
  },
  {
    path: ':id/',
    loadChildren: () => import('./pages/product-category/product-category.module').then(m => m.ProductCategoryPageModule),
    data: {
      type: 'category'
    }
  },
  // {
  //   path: 'post/edicion/:id/',
  //   loadChildren: () => import('./pages/share-chollo/share-chollo.module').then(m => m.ShareCholloPageModule),
  //   canActivate: [AuthUserGuard],
  //   data: {
  //     type: 'shop',
  //     edit: true
  //   }
  // },
  // {
  //   path: ':id/page/:page/',
  //   loadChildren: () => import('./pages/product-category/product-category.module').then(m => m.ProductCategoryPageModule),
  //   data: {
  //     type: 'category'
  //   }
  // },
  {
    path: ':id/:category/',
    loadChildren: () => import('./pages/product-category/product-category.module').then(m => m.ProductCategoryPageModule),
    data: {
      type: 'category'
    }
  },
  {
    // La página de error se MONTA aquí, sobre la URL que se pidió; no se redirige a
    // /pagina-no-encontrada/.
    //
    // Con `redirectTo` el router reescribía la barra de direcciones, y Googlebot
    // ejecuta JavaScript: cada URL inventada que rastreaba le enseñaba /pagina-no-
    // encontrada/ como una URL más, así que acabó en su índice y la re-rastrea sola.
    // En los logs que hay en disco se pide 1.442 veces, y 60 de ellas llegan desde
    // google.com: no es una página del sitio, es una que nos hemos fabricado nosotros.
    // Era el único sitio que la enlazaba (no hay ningún <a> ni entrada de sitemap).
    //
    // Montándola en su sitio, el SSR sigue respondiendo 404 + noindex sobre la URL
    // original (social-meta la marca notFound) y el visitante ve lo mismo que antes.
    // La ruta /pagina-no-encontrada/ se queda: la usa product-category.page.ts con
    // skipLocationChange, que no crea URL nueva.
    path: '**',
    loadChildren: () => import('./pages/not-found/not-found.module').then(m => m.NotFoundPageModule)
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: false,
      // Precarga todos los módulos lazy, pero esperando a que el navegador esté
      // ocioso: con PreloadAllModules la descarga arrancaba nada más terminar la
      // navegación inicial y competía con el primer render.
      preloadingStrategy: IdlePreloadStrategy,
      // enabledNonBlocking: enabledBlocking contradice la hidratación (NG05001) y
      // Angular abortaba la config. El catch-up de PageTrackerService.init() no
      // duplica page_view: está guardado por router.navigated (false con nonBlocking).
      initialNavigation: 'enabledNonBlocking',
      onSameUrlNavigation: 'reload',
      scrollPositionRestoration: 'enabled'
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
